module.exports = __webpack_public_path__ + "static/media/vida-vacations.7170a2e8.svg";